function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.85,66.23a66.78,66.78,0,0,1,27.91-8.94c30.71-2.33,57.1,19.95,71.62,44.17s21.79,51.79,38.94,74.58c12.74,16.94,30.33,30.4,46.19,45.08,19.67,18.22,39.42,41.32,35.08,68.22-4,25-24.44,46.66-48.23,59.33-29.73,15.84-64.84,20.83-98.89,26.12-48.27,7.51-96.9,16.26-145.78,14-29.57-1.4-60.92-7.86-80.83-27.36-16.42-16.07-22.53-38.77-22.68-60.59-.25-34.47,15-66.9,37.53-94.79,25.49-31.54,60.6-55.57,87-86.41,11.13-13,20.67-27.09,33.15-39A96.63,96.63,0,0,1,222.85,66.23Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.85,66.23a66.78,66.78,0,0,1,27.91-8.94c30.71-2.33,57.1,19.95,71.62,44.17s21.79,51.79,38.94,74.58c12.74,16.94,30.33,30.4,46.19,45.08,19.67,18.22,39.42,41.32,35.08,68.22-4,25-24.44,46.66-48.23,59.33-29.73,15.84-64.84,20.83-98.89,26.12-48.27,7.51-96.9,16.26-145.78,14-29.57-1.4-60.92-7.86-80.83-27.36-16.42-16.07-22.53-38.77-22.68-60.59-.25-34.47,15-66.9,37.53-94.79,25.49-31.54,60.6-55.57,87-86.41,11.13-13,20.67-27.09,33.15-39A96.63,96.63,0,0,1,222.85,66.23Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.57,
    y: 100.5,
    width: 176.87,
    height: 318.12,
    rx: 10.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.57,
    y: 100.5,
    width: 176.87,
    height: 318.12,
    rx: 10.4,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,111.16V407.4a4.33,4.33,0,0,1-4.4,4.33H147.46a3.88,3.88,0,0,1-3.92-4V110.8a3.5,3.5,0,0,1,3.36-3.64h39.15a2.75,2.75,0,0,1,2.52,1.76l1.62,4a2.77,2.77,0,0,0,2.53,1.74h66.65a2.71,2.71,0,0,0,2.52-1.72l1.62-4a2.78,2.78,0,0,1,2.53-1.77h38.59A4,4,0,0,1,308.47,111.16Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.54,
    y: 125.67,
    width: 164.93,
    height: 254.19,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.71,
    y: 116.39,
    width: 2.04,
    height: 2.72,
    transform: "translate(325.46 235.49) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.39,
    y: 115.48,
    width: 2.04,
    height: 3.62,
    transform: "translate(318.82 234.58) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.07,
    y: 114.57,
    width: 2.04,
    height: 4.53,
    transform: "translate(312.18 233.67) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.75,
    y: 113.67,
    width: 2.04,
    height: 5.43,
    transform: "translate(305.54 232.77) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.59,
    y: 115.39,
    width: 1.21,
    height: 2.72,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.63,
    y: 114.4,
    width: 9.62,
    height: 4.7,
    transform: "translate(590.88 233.5) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.12,
    y: 169.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.12,
    y: 169.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,202.82h-18a8.82,8.82,0,0,1-8.82-8.83h0a8.82,8.82,0,0,1,8.82-8.82h18a8.82,8.82,0,0,1,8.82,8.82h0A8.82,8.82,0,0,1,185.12,202.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.63,194a1.21,1.21,0,1,1-1.21-1.2A1.21,1.21,0,0,1,185.63,194Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,194a1.21,1.21,0,1,1-1.21-1.2A1.21,1.21,0,0,1,190.42,194Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,192.81a1.21,1.21,0,1,1,1.2-1.21A1.21,1.21,0,0,1,186.82,192.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,197.59a1.21,1.21,0,1,1,1.2-1.2A1.21,1.21,0,0,1,186.82,197.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.04 192.78 166.64 192.78 166.64 190.39 164.23 190.39 164.23 192.78 161.84 192.78 161.84 195.2 164.23 195.2 164.23 197.59 166.64 197.59 166.64 195.2 169.04 195.2 169.04 192.78",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.67,
    y: 194.55,
    width: 1.91,
    height: 0.79,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.67,
    y: 194.55,
    width: 1.91,
    height: 0.79,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.63,
    y: 174.62,
    width: 1,
    height: 9.49,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 169.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,178H225.66a5.49,5.49,0,0,0-5.48,5.48V187a5.49,5.49,0,0,0,5.48,5.49h5.49l1.93,3.87v-3.87h2.64A5.48,5.48,0,0,0,241.2,187v-3.58A5.48,5.48,0,0,0,235.72,178Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,178H225.66a5.49,5.49,0,0,0-5.48,5.48V187a5.49,5.49,0,0,0,5.48,5.49h5.49l1.93,3.87v-3.87h2.64A5.48,5.48,0,0,0,241.2,187v-3.58A5.48,5.48,0,0,0,235.72,178Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,187.18h10.06a5.48,5.48,0,0,1,5.48,5.48v3.58a5.48,5.48,0,0,1-5.48,5.49h-5.49l-1.93,3.86v-3.86h-2.64a5.48,5.48,0,0,1-5.48-5.49v-3.58A5.48,5.48,0,0,1,215.15,187.18Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,187.18h10.06a5.48,5.48,0,0,1,5.48,5.48v3.58a5.48,5.48,0,0,1-5.48,5.49h-5.49l-1.93,3.86v-3.86h-2.64a5.48,5.48,0,0,1-5.48-5.49v-3.58A5.48,5.48,0,0,1,215.15,187.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,200V178l-2,.93-8.8,4.15-7.71-4-2-1v19.39a5.8,5.8,0,0,0-2.52-.56c-2.49,0-4.5,1.44-4.5,3.22s2,3.21,4.5,3.21,4.49-1.43,4.5-3.21h0V187l8.25,3.83,8.26-4.39v10.87a5.91,5.91,0,0,0-2.52-.55c-2.48,0-4.5,1.44-4.5,3.22s2,3.21,4.5,3.21,4.5-1.44,4.5-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.12,
    y: 219.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.12,
    y: 219.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 219.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.42,
    y: 231.62,
    width: 25.58,
    height: 17.27,
    rx: 3.1,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.57 236.25 220.57 244.26 231.85 240.26 220.57 236.25",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.3,248a1.79,1.79,0,1,0,1.78,1.79A1.78,1.78,0,0,0,168.3,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,248a1.79,1.79,0,1,0,1.78,1.79A1.78,1.78,0,0,0,183.42,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.44,239.34l.95-5.57a1,1,0,0,0-.22-.81,1,1,0,0,0-.76-.35H167l-3.63-1a1,1,0,0,0-1.22.71,1,1,0,0,0,.71,1.22l3.13.84,1.89,11.1a1,1,0,0,0,1,.83h14.51a1,1,0,0,0,1-.83l1-5.57a1,1,0,0,0,.13-.47A.79.79,0,0,0,185.44,239.34Zm-1.88-.87h-3.24l.19-3.86h3.71Zm-8.88,0-.2-3.86h4l-.2,3.86Zm3.53,2-.19,3.87H175l-.19-3.87Zm-5.73-5.86.19,3.86h-3.92l-.66-3.86Zm-3.39,5.86h3.68l.2,3.87h-3.22ZM180,244.34l.19-3.87h3l-.66,3.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.87,233h-2.4v-2.4a1,1,0,0,0-2,0V233h-2.4a1,1,0,0,0,0,2h2.4v2.4a1,1,0,0,0,2,0V235h2.4a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.12,233h-6.8a1,1,0,0,0,0,2h6.8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.83,243.76a1,1,0,0,0-1.42,0l-1.69,1.69-1.7-1.69a1,1,0,1,0-1.41,1.41l1.69,1.7-1.69,1.69A1,1,0,0,0,281,250l1.7-1.7,1.69,1.7a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42l-1.7-1.69,1.7-1.7A1,1,0,0,0,285.83,243.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.37,243.87h-5.8a1,1,0,0,0,0,2h5.8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.37,247.87h-5.8a1,1,0,0,0,0,2h5.8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 205.12,
    y: 269.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.12,
    y: 269.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 269.54,
    width: 41.77,
    height: 41.77,
    rx: 5.46,
    style: {
      fill: "#38B2AC",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.51,
    y: 277.32,
    width: 17.71,
    height: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.09,
    y: 280.77,
    width: 12.55,
    height: 1.71,
    rx: 0.86,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.78,284.65H169a.85.85,0,0,0-.86.85h0a.85.85,0,0,0,.86.86h10.83a.85.85,0,0,0,.86-.86h0A.85.85,0,0,0,179.78,284.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.09,
    y: 288.53,
    width: 12.55,
    height: 1.71,
    rx: 0.86,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.78,292.41H169a.85.85,0,0,0-.86.86h0a.85.85,0,0,0,.86.85h10.83a.85.85,0,0,0,.86-.85h0A.85.85,0,0,0,179.78,292.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.09,
    y: 296.29,
    width: 8.55,
    height: 1.71,
    rx: 0.86,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.22 280.11 183.22 301.45 167.12 301.45 167.12 303.77 183.22 303.77 185.52 303.77 185.52 301.45 185.52 280.11 183.22 280.11",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,280.11v20.72H263.09V280.11H267v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,1,0,1.53,0v-1.49h2.6v1.49a.77.77,0,1,0,1.53,0v-1.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,280.11v3.63H263.09v-3.63H267v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,0,0,1.54,0v-1.49h2.59v1.49a.77.77,0,1,0,1.53,0v-1.49h2.6v1.49a.77.77,0,1,0,1.53,0v-1.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.75,282.37h0a.77.77,0,0,1-.77-.77v-2.54a.78.78,0,0,1,.77-.77h0a.78.78,0,0,1,.77.77v2.54A.77.77,0,0,1,267.75,282.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.11,
    y: 278.29,
    width: 1.53,
    height: 4.08,
    rx: 0.77,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,282.37h0a.76.76,0,0,1-.77-.77v-2.54a.77.77,0,0,1,.77-.77h0a.77.77,0,0,1,.76.77v2.54A.76.76,0,0,1,276,282.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,282.37h0a.76.76,0,0,1-.77-.77v-2.54a.77.77,0,0,1,.77-.77h0a.77.77,0,0,1,.76.77v2.54A.76.76,0,0,1,280.14,282.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.27,282.37h0a.76.76,0,0,1-.77-.77v-2.54a.77.77,0,0,1,.77-.77h0a.77.77,0,0,1,.76.77v2.54A.76.76,0,0,1,284.27,282.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.36,
    y: 286.57,
    width: 7.71,
    height: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.93,
    y: 286.57,
    width: 7.71,
    height: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.36,
    y: 292.57,
    width: 7.71,
    height: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.93,
    y: 292.57,
    width: 7.71,
    height: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,107.55a2.26,2.26,0,1,1-2.26-2.26A2.27,2.27,0,0,1,226,107.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,107.55a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,230.56,107.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.21,154.81H166a7.68,7.68,0,0,1-7.68-7.68h0a7.68,7.68,0,0,1,7.68-7.68H289.21a7.68,7.68,0,0,1,7.68,7.68h0A7.68,7.68,0,0,1,289.21,154.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,292.71v-3.24l-1.67-.16a8.79,8.79,0,0,0-1.25-3l1.07-1.3L232,282.73l-1.3,1.07a8.43,8.43,0,0,0-3-1.24l-.16-1.67h-3.24l-.16,1.67a8.43,8.43,0,0,0-3,1.24l-1.3-1.07L217.55,285l1.07,1.3a8.58,8.58,0,0,0-1.24,3l-1.67.16v3.24l1.67.16a8.55,8.55,0,0,0,1.24,3l-1.07,1.29,2.29,2.29,1.3-1.07a8.63,8.63,0,0,0,3,1.25l.16,1.67h3.24l.16-1.67a8.63,8.63,0,0,0,3-1.25l1.3,1.07,2.29-2.29-1.07-1.29a8.76,8.76,0,0,0,1.25-3Zm-10.21,2.77a4.39,4.39,0,1,1,4.39-4.39A4.39,4.39,0,0,1,225.91,295.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,327.53a2.48,2.48,0,1,1-2.47-2.47A2.48,2.48,0,0,1,215.11,327.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14,327.53a2.48,2.48,0,1,1-2.48-2.47A2.48,2.48,0,0,1,229.14,327.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.16,327.53a2.48,2.48,0,1,1-2.47-2.47A2.48,2.48,0,0,1,243.16,327.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.76,161.63c-14.49,5.68-24.44,68.45-25.63,94.23h3.14s3.75-40.2,9.83-62.59S356.76,161.63,356.76,161.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,164.93s4.93-.09,5.1.78-.15,8.09-.81,9.1a15,15,0,0,1-2.45,2.48l.47,4.71-6.08,3.09.48-5.69s-3-3-2.14-6.69S406.36,164.93,406.36,164.93Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,164.93s4.93-.09,5.1.78-.15,8.09-.81,9.1a15,15,0,0,1-2.45,2.48l.47,4.71-6.08,3.09.48-5.69s-3-3-2.14-6.69S406.36,164.93,406.36,164.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,169c2.89,2,6.31,17.46,7.63,18.25s2-5.09,2-5.09l6.86-1.25s1.89,13.45-1.78,16.15c-2.9,2.14-8.44,2.44-18.55-8.11C379.48,179.29,392.64,169,392.64,169Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,169c2.89,2,6.31,17.46,7.63,18.25s2-5.09,2-5.09l6.86-1.25s1.89,13.45-1.78,16.15c-2.9,2.14-8.44,2.44-18.55-8.11C379.48,179.29,392.64,169,392.64,169Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,163.08s15.92-6.7,43.2,6c0,0-6.66,34.83-6.07,52.09l-41.65-2.57S342.93,180.86,349.44,163.08Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,163.08s15.92-6.7,43.2,6c0,0-6.66,34.83-6.07,52.09l-41.65-2.57S342.93,180.86,349.44,163.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.44 389.53 343.69 395.6 356.55 384.06 351.3 378 338.44 389.53",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.3 378 356.55 384.06 349.91 390.01 344.66 383.94 351.3 378",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.61,244.24l-1.43-22.54-40.52,1.57s-3.09,18.59,1.11,37l11-1.76c6.71,18.64,22.94,65.79,19.17,75.63-4.72,12.33-29.6,44.57-29.6,44.57l10.26,10.23s43.91-39,46.63-64.36C405.23,305.46,392.67,260.64,386.61,244.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.06,394.31l-6.86-6.42a.66.66,0,0,0-.84-.06l-5.82,4a1.14,1.14,0,0,0-.28,1.59,1,1,0,0,0,.17.19c2.25,2,4,3.41,6.78,6,1.71,1.61,6.72,6.64,9.09,8.85s4.87.17,4.1-.95c-3.46-5-5.5-9.4-5.73-12A1.8,1.8,0,0,0,346.06,394.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,395.45a.18.18,0,0,1,0-.21.17.17,0,0,1,.19-.06c.32.05,3.19.64,3.51,1.55a.54.54,0,0,1-.12.59,1.06,1.06,0,0,1-.95.45,2.27,2.27,0,0,1-1.35-.72A8.9,8.9,0,0,1,345.72,395.45Zm.56.18a3.76,3.76,0,0,0,2.1,1.78.74.74,0,0,0,.63-.31c.1-.12.1-.21.06-.24a.39.39,0,0,0-.13-.2A7.59,7.59,0,0,0,346.28,395.63Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.65,395.45a.22.22,0,0,1,.05-.18c.08-.08,1.74-1.57,2.89-1.49a1,1,0,0,1,.73.36.59.59,0,0,1,.1.75c-.44.71-2.73.89-3.61.66l-.07-.06A.18.18,0,0,1,345.65,395.45Zm3-1.35a4.28,4.28,0,0,0-2.32,1.14c1,.11,2.59-.16,2.86-.6,0,0,.11-.15-.06-.31l-.07-.06A.57.57,0,0,0,348.61,394.1Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.44 392.91 343.64 379.29 347.27 376.18 358.73 390.12 354.44 392.91",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.44 392.91 343.64 379.29 347.27 376.18 358.73 390.12 354.44 392.91",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.02 410.71 370.75 410.71 371.39 392.8 363.65 392.8 363.02 410.71",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.83,409.82h-9.4a.68.68,0,0,0-.66.53l-1.52,6.89a1.14,1.14,0,0,0,.88,1.35,1.06,1.06,0,0,0,.25,0c3-.05,5.25-.23,9.07-.23,2.35,0,9.44.24,12.69.24s3.67-3.2,2.34-3.5c-6-1.3-10.45-3.1-12.36-4.81A1.86,1.86,0,0,0,371.83,409.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,410.89a.18.18,0,0,1-.14-.16.15.15,0,0,1,.09-.17c.27-.18,2.77-1.71,3.63-1.27a.54.54,0,0,1,.31.51,1.08,1.08,0,0,1-.38,1,2.32,2.32,0,0,1-1.49.4A9.2,9.2,0,0,1,372.36,410.89Zm.53-.25a3.79,3.79,0,0,0,2.75-.14.75.75,0,0,0,.25-.66c0-.15-.07-.22-.12-.22a.47.47,0,0,0-.24-.05A7.61,7.61,0,0,0,372.89,410.64Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,410.93a.2.2,0,0,1-.09-.17c0-.1.2-2.33,1.09-3.05a1,1,0,0,1,.78-.24.6.6,0,0,1,.59.48c.16.82-1.39,2.52-2.18,2.95h-.09A.19.19,0,0,1,372.31,410.93Zm1.24-3a4.3,4.3,0,0,0-.92,2.42c.8-.6,1.78-1.89,1.68-2.39,0-.05,0-.19-.26-.19H374A.62.62,0,0,0,373.55,407.92Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.65 392.81 371.39 392.81 371.06 402.05 363.32 402.05 363.65 392.81",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,166.71a5.92,5.92,0,0,1-2.53-5.22,9.93,9.93,0,0,1,1.16-3.71c.32-.64.7-1.27,1.09-1.89l-7.31-12.17c-.75,5.73-3,15.91-7.94,18.23C368.64,170.43,377.93,166.71,377.93,166.71Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.72,149.69c-2.2,6.5,2.28,10.4,4.68,11.8a9.93,9.93,0,0,1,1.16-3.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.73,133.63s-.21,10.78-6.48,13.85-2.9-16.46-2.9-16.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63,153a9.67,9.67,0,0,0,10.31,5.58,10.74,10.74,0,0,0,6.91-3.89c.24-.29.46-.6.68-.92,3.84-5.94,6.65-17,.59-22.39A10.48,10.48,0,0,0,372,136.48C369.87,143.84,368.28,148.07,370.63,153Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24,142.37a1,1,0,0,0,.33,1.31c.39.14.86-.23,1.07-.82s.06-1.17-.32-1.31S382.46,141.78,382.24,142.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,144.72a1,1,0,0,0,.32,1.31c.39.13.87-.24,1.08-.82s.06-1.17-.32-1.31S389.09,144.17,388.89,144.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.68,144.27a22,22,0,0,0,1,6,3.63,3.63,0,0,1-3-.47Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,139.49a.39.39,0,0,0,.39,0,3,3,0,0,1,2.61-.38.36.36,0,0,0,.48-.19.37.37,0,0,0-.18-.48h0a3.62,3.62,0,0,0-3.3.43.36.36,0,0,0-.12.5h0A.49.49,0,0,0,380.94,139.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,152.52h0a5.6,5.6,0,0,1-4.07-3.21.19.19,0,0,1,.11-.25.19.19,0,0,1,.25.1h0a5.4,5.4,0,0,0,3.79,3,.2.2,0,0,1,.16.21v0a.18.18,0,0,1-.21.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,143.44a.34.34,0,0,0,.2.09.36.36,0,0,0,.32-.4h0a3.62,3.62,0,0,0-1.8-2.82.36.36,0,0,0-.49.16h0a.37.37,0,0,0,.17.48h0a3,3,0,0,1,1.39,2.26A.37.37,0,0,0,392.56,143.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.48,129.35l-.58,3.35a2.51,2.51,0,0,0-2.12,2.67c.23,3-2.59,6.78-5.18,7.84,0,0,.29-1.2-.79-1.22s-2.64,6.2-1.58,9.71c0,0-2.14-3.53-1.86-10.47.26-6.41,1.56-11.44,3.48-13.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,141.29a7.33,7.33,0,0,0,2.71,4.86c2,1.58,4,0,4.25-2.4.21-2.14-.55-5.61-3-6.22S366.51,138.93,366.75,141.29Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,132.7s2.77,3.12,4.24,2.53.61-2.27.61-2.27,3.9,4,6.11,4.36,1.15-3.11,1.15-3.11,1.88,5.44,3.74,4.52c.89-.44,2.71-5.91-3.41-10.87S378.55,123.1,376,125a6,6,0,0,0-6.23,4C367.66,135,379.9,132.7,379.9,132.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.64,170.26a.74.74,0,0,0,.68.91l8.39.71a1,1,0,0,0,1-.77L410,154.72a.84.84,0,0,0-.68-1l-8.38-.71a1.09,1.09,0,0,0-1,.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.85,153.84l-3.31,16.55a.63.63,0,0,0,.59.84l7.11.61c.48,0,1.37-.15,1.47-.62L410,154.61c.1-.46-.69-.91-1.16-1l-7.11-.6A.86.86,0,0,0,400.85,153.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.66,220.25c-7.55,39.42,18,94,15.89,178.53h14.14s11.49-58.87,2.59-158.87l7.9-18.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.66,220.25c-7.55,39.42,18,94,15.89,178.53h14.14s11.49-58.87,2.59-158.87l7.9-18.21Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.31 400.56 359.63 400.56 359.63 395.58 376.94 395.25 376.31 400.56",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.31 400.56 359.63 400.56 359.63 395.58 376.94 395.25 376.31 400.56",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.85 169.04 374.41 175.01 372.63 210.03 375.68 213.59 377.93 210.42 376.56 175.01 377.93 167.52 376.99 165.84 370.24 167.52 370.85 169.04",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.92 218.56 386.57 221.13 385.78 226.43 344.15 223.27 344.92 218.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.19,220.68a1.92,1.92,0,0,0-1.39-.71l-3.91-.24a1.92,1.92,0,0,0-2,1.65l-.36,2.46a2,2,0,0,0,.41,1.51,1.91,1.91,0,0,0,1.22.7h.17l3.91.24a1.94,1.94,0,0,0,2-1.65l.36-2.46A2,2,0,0,0,377.19,220.68Zm-1.93,4.62-3.91-.23a1,1,0,0,1-.68-.35,1,1,0,0,1-.19-.73l.36-2.47a.94.94,0,0,1,1-.8l3.91.25h.08a1,1,0,0,1,.59.34.93.93,0,0,1,.2.73l-.05.38-.15,0-1.1-.07a.65.65,0,0,0-.7.61.66.66,0,0,0,.61.71l1.09.08h.06l-.12.81A.94.94,0,0,1,375.26,225.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,159.3l8.39,6.54,2.87-4.53,4.13,3.13s1.38,4.66-1.64,7.52l-4.7-3.87L370.13,172s-7.92-6.62-9.28-8.61S365.36,159.3,365.36,159.3Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,159.3l8.39,6.54,2.87-4.53,4.13,3.13s1.38,4.66-1.64,7.52l-4.7-3.87L370.13,172s-7.92-6.62-9.28-8.61S365.36,159.3,365.36,159.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,161.63c9.06,10.24,7.35,96.62,7.35,96.62l3.06.57s2.64-86.62-8.39-97.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,181.87l8.91-5.63s1.62-9.91,2.18-11,8.65-.16,9.53-.18.14,9.93-.77,10.92-4.27,1.64-4.27,1.64l-9.74,9.08Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,163.08c5.14-2.79,18.83,20,20.65,21.56S388.34,178,388.34,178l4.3,6.49s-14.92,10.55-23.13,12.13S350.1,182.06,348.58,178C344.63,167.52,349.44,163.08,349.44,163.08Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,163.08c5.14-2.79,18.83,20,20.65,21.56S388.34,178,388.34,178l4.3,6.49s-14.92,10.55-23.13,12.13S350.1,182.06,348.58,178C344.63,167.52,349.44,163.08,349.44,163.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.34,255.86l-35.18-4.94s-.39,38.37,1.22,40.48,33.4,8.86,35.94,6.68S366.34,255.86,366.34,255.86Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.42,163.75s-7.65-4.26-13.89-1.09-5.94,26.7-7.32,28.88-4.95,4.05-4.95,4.05a64.07,64.07,0,0,0,21,4,82.81,82.81,0,0,0,19-2.07S148.25,159.89,128.42,163.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.49 400.49 103.28 397.54 101.17 388.9 99.23 380.98 91.95 383.36 94.88 392.44 97.49 400.49",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,396.18c-.34-.64-8.1,3.86-8.1,3.86s-2.43,7.47-6.66,11-.12,5.05,5.24,2.38l13.23-6.59C112.4,404.92,108.41,402.86,104.88,396.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79,404.35c-.22-.05-.51-.22-.62-.76a1,1,0,0,1,.15-.76,3.82,3.82,0,0,1,1.7-1.09c-.82,0-1.6-.16-1.84-.57a.83.83,0,0,1,.19-.93,1.42,1.42,0,0,1,1-.55c1.31-.09,2.91,1.44,3,1.51a.24.24,0,0,1,.06.09h0a.13.13,0,0,1,0,.06h0a.11.11,0,0,1,0,.08h0a.12.12,0,0,1,0,.08,14.19,14.19,0,0,1-2.25,2.32A1.94,1.94,0,0,1,92.79,404.35Zm-.07-1.25a.48.48,0,0,0-.09.39c.07.35.22.39.26.4.53.12,1.78-1.05,2.71-2.14C94.61,402,93.13,402.48,92.72,403.1Zm0-2.57c-.09.11-.22.3-.16.41.2.35,1.66.4,3.07.26a3.93,3.93,0,0,0-2.23-1,.91.91,0,0,0-.49.18A.85.85,0,0,0,92.75,400.53Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.95 392.62 101.23 389.06 99.27 381.06 91.96 383.4 94.95 392.62",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.69 407.71 114.3 407.71 116.19 399.22 117.91 391.43 110.18 390.25 108.86 399.5 107.69 407.71",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.49,407.45c0-.73-9-.16-9-.16s-5.51,5.61-10.86,6.86-2.36,4.47,3.62,4.47h14.79C119.32,418.62,116.66,415,116.49,407.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,409.37a.86.86,0,0,1-.22-.95,1,1,0,0,1,.48-.61,3.74,3.74,0,0,1,2-.22c-.73-.39-1.37-.86-1.4-1.33,0-.31.19-.56.59-.75a1.39,1.39,0,0,1,1.16,0c1.22.5,2,2.59,2,2.68a.22.22,0,0,1,0,.18l0,.05h0a.16.16,0,0,1-.08.06,11.08,11.08,0,0,1-3.71,1.14A1.24,1.24,0,0,1,102,409.37Zm.5-1.15a.49.49,0,0,0-.26.31c-.09.35,0,.45.06.48.42.34,2.06-.15,3.38-.71C104.69,408.08,103.16,407.85,102.52,408.22Zm1.17-2.28c-.13.05-.33.17-.32.29,0,.41,1.3,1.1,2.63,1.61a4,4,0,0,0-1.54-1.93.92.92,0,0,0-.36-.07A.86.86,0,0,0,103.69,405.94Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.84 399.68 116.17 399.39 117.9 391.51 110.18 390.29 108.84 399.68",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.92,252.15l-16.23-2.6-14.71-3-4,24s-20.71,30-25.73,50.63S93.1,389.67,93.1,389.67l8.65-3.83s-6-46-5.86-51.59c.09-3.6,11.9-20.2,20.16-31.38.24,2.8-2.44,30.81-2.44,30.81l-5.83,61.41h10.86C156.12,278.74,139.92,252.15,139.92,252.15Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64,395.09H107.78l5.83-61.4s2.66-28.2,2.44-30.82c-1.63,2.21-3.4,4.62-5.19,7.11-7.27,10.11-14.9,21.38-15,24.27-.14,5.54,5.86,51.59,5.86,51.59l-8.65,3.83s-18.83-47.9-13.81-68.53S105,270.51,105,270.51l4-24,14.71,3,16.23,2.6S156.12,278.74,118.64,395.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.2 381.97 89.43 386.36 92.28 390.74 102.77 386.99 102.2 381.97",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.2 393.61 106.55 391.75 107.22 396.85 118.5 398.27 120.2 393.61",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.05,302.87c-1.63,2.21-3.4,4.62-5.19,7.11,2.86-14.82,6.23-29.25,6.23-29.25A106.13,106.13,0,0,1,116.05,302.87Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,203.06c-3,.14-15.52,17-15.52,17L89.72,214s-7.17,13.94-3.62,20.57,22.25-11.5,22.25-11.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67,216.49l-.32,6.56s-3.07,3-7,6.08c-.37-7.88,7-19.36,7-19.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38,220l.67,1.28-2,7.59s5.38-4.9,2-9.7Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,206.63c-.68,1.73-1.3,3.39-1.86,4.94s-1.19,3.22-1.7,4.7c-1.23,3.48-2.19,6.49-3,9.16-2.36,8.25-2.76,24.11-2.76,24.11l-29.61-2c-1.2-18.84-1.46-33.36-.91-38.54.6-5.51,1.54-5.72,1.54-5.72l2.08-.16c2.43-.17,6.6-.42,10.4-.39a107.16,107.16,0,0,1,13.4,1.27q4.51.68,8.92,1.76h0C145.87,206,147,206.3,148.16,206.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,226.56s8.16,16.66,18.69,22.06c.13-3.47.71-16.12,2.73-23.19.54-1.91,1.19-4,2-6.29l-3.21-3.46a26.91,26.91,0,0,0-2.91,8.91L127,218Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.08,
    cy: 251.04,
    r: 1.5,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.24 215.36 94 208.99 97.53 212.32 94.38 220.03 90.24 215.36",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.73 214.64 89.97 213.39 95.89 220.03 95.05 222.66 88.73 214.64",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.74 212.84 117.32 214.25 128.16 226.57 130.33 222.13 120.74 212.84",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,206.54c5.1,2.56,7.38,31.41-1.49,36.39s-22.13-17.53-22.13-17.53l5.15-5.46s10.8,9,12.1,8.21-.18-9.67-.18-9.67-1.51-2.67,1.68-6.87S147.73,206.54,147.73,206.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.02 227.4 122.47 226.48 128.26 218 130.38 219.18 124.02 227.4",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.5 249.54 139.75 252.62 108.23 251.04 108.89 247.25 138.5 249.54",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.86,248.39l-.37,3.47a.7.7,0,0,1-.75.62l-4.62-.36a.71.71,0,0,1-.64-.77l.32-3.41a.71.71,0,0,1,.75-.64l4.66.32A.7.7,0,0,1,121.86,248.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.37,209c7.47-1.34,9.57-4.67,9.57-4.67-5-4.25-1.44-12.25-1.44-12.25l-9,2.15a26,26,0,0,1,.55,3.79c.35,5.49-2.13,5.67-2.13,5.67C119.52,206.69,123.37,209,123.37,209Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,194.18a26,26,0,0,1,.55,3.79c4.31-1.24,8.41-5.94,8.41-5.94Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21,168.52c-7.86.71-10,5.14-9.86,13.29.19,10.18,3.08,17.17,12.71,14.13C139.14,191.8,136.25,167.35,123.21,168.52Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,180.92a16.46,16.46,0,0,1-2,3.46,2.16,2.16,0,0,0,2.15.7Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14,179.84c0,.65.43,1.15.86,1.12s.75-.58.7-1.22-.42-1.15-.86-1.12S123.1,179.19,123.14,179.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,178.64l-1.45-.46S123.36,179.32,124,178.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,180.24c0,.65.43,1.15.86,1.12s.75-.58.7-1.22-.42-1.15-.85-1.12S115.05,179.59,115.09,180.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,179l-1.45-.46S115.31,179.72,116,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73,174.41a4.11,4.11,0,0,1,3.52.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,174.59a3.67,3.67,0,0,0-3.07.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,181s-4.25-6.12-4.14-11.15c0,0-16.14-5-15.49,10.91,0,0-2.78-13.9,10.69-15.42s15.2,18.23,8.75,24.74C132.79,190.07,135.62,184.83,133,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85,182.77a3.47,3.47,0,0,1,3.42-3.49c2.46.05,4.07,4.94-1.87,6.69C132.54,186.22,132,185.42,131.85,182.77Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09,188.39s3.3.27,4.21-2.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.707962px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7,205.71c-.34.28-7.37,5.88-21.71,4.07-11.37-1.44-13-4.56-11-6.71,2.43-.17,6.6-.42,10.4-.39a107.16,107.16,0,0,1,13.4,1.27Q140.29,204.63,144.7,205.71Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,203.22l1.82,8.13a2.33,2.33,0,0,0,2.2,1.72h16.28a1.36,1.36,0,0,0,1.42-1.72l-1.82-8.13a2.32,2.32,0,0,0-2.19-1.72H97.19A1.37,1.37,0,0,0,95.77,203.22Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,203.22l1.82,8.13a2.33,2.33,0,0,0,2.2,1.72h14.76a1.36,1.36,0,0,0,1.42-1.72l-1.82-8.13A2.32,2.32,0,0,0,112,201.5H97.19A1.37,1.37,0,0,0,95.77,203.22Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,207.43c.93-.68,6-2.75,6.78-2s3,6.9,4,7.7a43.77,43.77,0,0,1-2.79,3.42,13.32,13.32,0,0,1-2.77-.69C115,215.45,109.64,208.11,110.56,207.43Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.91,209.56c-.13-.29-2.35-5.75-3-5.64s-3.15,2.73-2.92,3.52S95.49,214,96.41,214s2.93,0,2.93,0A10.85,10.85,0,0,0,98.91,209.56Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.75,169.51s-2.83,3.94,2.3,10.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.707962px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.88,330h6.25l-2.69-8a14.79,14.79,0,0,0,2.35-2.37c.63-1,.94-7.9.77-8.73s-4.89-.75-4.89-.75-4.36,3.87-5.21,7.46,2.05,6.42,2.05,6.42Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.88,330h6.25l-2.69-8a14.79,14.79,0,0,0,2.35-2.37c.63-1,.94-7.9.77-8.73s-4.89-.75-4.89-.75-4.36,3.87-5.21,7.46,2.05,6.42,2.05,6.42Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,319c4.5,3.92,11,18.38,12.77,15.57s.14-4.24.44-5.19l.3-.95s3.81,1.17,5.61-1.4c0,0,1.68.87,1.81,2.07s2.56,7.44.23,13.33c-1.61,4.07-6.56,8.14-24.52-.7C245.91,334.94,263,319,263,319Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,319c4.5,3.92,11,18.38,12.77,15.57s.14-4.24.44-5.19l.3-.95s3.81,1.17,5.61-1.4c0,0,1.68.87,1.81,2.07s2.56,7.44.23,13.33c-1.61,4.07-6.56,8.14-24.52-.7C245.91,334.94,263,319,263,319Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,421.54C199,420,214.06,363.86,214.06,363.86l50.68,1.75s7.53,16.25,15.07,23.72S248.29,421.54,248.29,421.54Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,421.54C199,420,214.06,363.86,214.06,363.86l50.68,1.75s7.53,16.25,15.07,23.72S248.29,421.54,248.29,421.54Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.39,381s59.88-10.4,65.14,10.78S282.27,424,252.91,422s-39.25-23.66-28.66-42.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.39,381s59.88-10.4,65.14,10.78S282.27,424,252.91,422s-39.25-23.66-28.66-42.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.15,419.87a.2.2,0,0,1-.22,0,.15.15,0,0,1,0-.18c.13-.32,1.38-3,2.39-3.23a.6.6,0,0,1,.57.23,1,1,0,0,1,.25,1,2.62,2.62,0,0,1-1.05,1.23A11.24,11.24,0,0,1,320.15,419.87Zm.3-.52a4.19,4.19,0,0,0,2.29-1.8.63.63,0,0,0-.18-.67.22.22,0,0,0-.22-.09.66.66,0,0,0-.24.11A8.32,8.32,0,0,0,320.45,419.35Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.09,419.9a.16.16,0,0,1-.17-.07c-.09-.09-1.27-1.93-.93-3.06a1.08,1.08,0,0,1,.54-.66.65.65,0,0,1,.79,0c.65.57.34,2.85-.1,3.68l0,.08A.17.17,0,0,1,320.09,419.9Zm-.43-3.42a.69.69,0,0,0-.27.38,4,4,0,0,0,.66,2.44c.33-1,.41-2.56,0-2.89,0,0-.12-.11-.35,0l-.07.05Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,424.25a.17.17,0,0,1,.17-.13.15.15,0,0,1,.16.1c.13.32,1.2,3.11.63,4a.61.61,0,0,1-.56.25,1,1,0,0,1-.88-.51,2.69,2.69,0,0,1-.14-1.61A9.88,9.88,0,0,1,259.74,424.25Zm.15.57a4.22,4.22,0,0,0-.31,2.9.64.64,0,0,0,.6.34.23.23,0,0,0,.22-.1.58.58,0,0,0,.09-.25A8.2,8.2,0,0,0,259.89,424.82Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.82 405.99 264.76 412.51 259.44 415.64 262.11 421.61 267.41 419.36 280.35 413.88 275.82 405.99",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,421.6l-2.42-7.18a.75.75,0,0,0-1-.46l-3.51,1.31s-4.86,1.42-5.6,2.87c-2.16,4.26,2.79,20.27,4.81,20.48.74.07,1.3-1,1.48-1.75.56-2.29,1.2-8.14,1.69-10,.58-2.23,3-3.74,4.17-4.33A.74.74,0,0,0,263.72,421.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,424.18a.16.16,0,0,1,.18-.07c.12,0,2.26.45,2.83,1.48a1.07,1.07,0,0,1,.09.84.63.63,0,0,1-.55.56c-.87.07-2.27-1.74-2.56-2.64l0-.08A.41.41,0,0,1,259.75,424.18Zm2.75,2.09a.7.7,0,0,0-.08-.47,3.93,3.93,0,0,0-2.21-1.22c.45.89,1.54,2.08,2.05,2,.05,0,.15,0,.22-.27l0-.08Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.82 405.99 264.76 412.51 267.41 419.36 280.35 413.88 275.82 405.99",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.72 420.02 273.19 419.61 268.63 408.3 265.17 411.19 269.72 420.02",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.72 420.02 273.19 419.61 268.63 408.3 265.17 411.19 269.72 420.02",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.85 421.15 308.25 424.49 314.21 426.1 316.6 420.02 311.29 417.8 298.32 412.38 295.85 421.15",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.47,418.87,312,425.62a.75.75,0,0,0,.34,1l3.4,1.59s4.41,2.48,6,2c4.55-1.44,12.53-16.17,11.26-17.76-.47-.59-1.64-.21-2.28.17-2,1.2-6.66,4.83-8.36,5.81-2,1.15-4.8.45-6,.05A.75.75,0,0,0,315.47,418.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.85 421.15 308.25 424.49 311.29 417.8 298.32 412.38 295.85 421.15",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25,416.28s-49.32-36.2-67.14-37.16S221,395.67,227.29,406.19s19.62,14.27,19.62,14.27-7.9-13.93-6.2-17.46,5.53,9.29,5.53,9.29,32.06,7.52,60.11,12.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.16 415.56 307.45 413.32 302.55 424.43 307.04 424.88 310.16 415.56",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.16 415.56 307.45 413.32 302.55 424.43 307.04 424.88 310.16 415.56",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,368.15s-12.54,6.27-53.86-1c0,0,.66-48.15,19.95-54.95C248,306.93,263,319,263,319l0,4.63.11,15.43a35.2,35.2,0,0,1,2.55,5.36A42.37,42.37,0,0,1,267.08,368.15Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,368.15s-12.54,6.27-53.86-1c0,0,.66-48.15,19.95-54.95C248,306.93,263,319,263,319l0,4.63.11,15.43a35.2,35.2,0,0,1,2.55,5.36A42.37,42.37,0,0,1,267.08,368.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,322.75s-12.82-8.82-19.71-6.45c0,0-5.35-1.49-1.13-8.68s24.85-5.65,30.24,1.09S261.33,322.9,246.65,322.75Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,322.75s-12.82-8.82-19.71-6.45c0,0-5.35-1.49-1.13-8.68s24.85-5.65,30.24,1.09S261.33,322.9,246.65,322.75Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,316.21c-7.33,8-20.68-4-20.68-4,7.86-1.75,4.68-15.81,4.68-15.81l12.65,6a28.12,28.12,0,0,0-.62,8.19C250.46,316.29,253.85,316.21,253.85,316.21Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,310.54a14.69,14.69,0,0,1-11-10.46l10.29,1.65,1.31.62A28.12,28.12,0,0,0,249.88,310.54Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.47,282.87c-3.44,1.56-2.65,5.33,3.35,12.07,3.45-3.17,5.16-10.2,3.22-12.38S257.46,281.53,254.47,282.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.25,286.31s-4.69,11.36,2.19,17.58c5,4.51,11.9,5.46,17-.13,4-4.37,1.61-9.93,1.61-9.93.82-5.72-.11-12-4.76-15a10.42,10.42,0,0,0-16,7.51Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,290.5c-.12.6.11,1.16.51,1.23s.81-.35.92-1-.1-1.16-.5-1.24S251.19,289.9,251,290.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,291.83c-.12.61.11,1.16.51,1.24s.82-.35.94-1-.12-1.17-.52-1.24S258.07,291.22,258,291.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.64,291.68a22.63,22.63,0,0,0,1.92,5.77,3.6,3.6,0,0,1-3,0Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.56,288a.36.36,0,0,1-.22-.09.38.38,0,0,1,0-.52,3.62,3.62,0,0,1,3.2-.92.35.35,0,0,1,.27.42v0a.38.38,0,0,1-.45.26h0a2.9,2.9,0,0,0-2.51.76A.39.39,0,0,1,249.56,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,290.09a.37.37,0,0,1-.29-.26,2.89,2.89,0,0,0-1.71-2,.38.38,0,0,1-.23-.47.36.36,0,0,1,.45-.23,3.61,3.61,0,0,1,2.19,2.51.36.36,0,0,1-.25.44h0A.26.26,0,0,1,261.56,290.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5,280.25c3.27,1.86,2.12,5.55-4.49,11.68-3.14-3.49-4.17-10.66-2-12.63S241.64,278.62,244.5,280.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,291.61a7.28,7.28,0,0,0,2.57,4.92c2,1.61,4,.09,4.28-2.3.27-2.15-.42-5.58-2.8-6.26A3.23,3.23,0,0,0,235.55,291.61Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,296.39a5.33,5.33,0,0,0,3.55,4.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,279.46a9,9,0,0,1-9.59,5.77c-7.29-.82-7.68-3.25-7.68-3.25s2.64.09,3.31.19c0,0-3.56-5.28-.9-8.1s10.44-4.88,15.48-2.25c0,0,5.65-1.1,10,2.64,6.54,5.68,2.67,9.07,2.67,9.07s1.15-2.1-1.34-4.82c0,0,1.65,7.66-3,8.82C261.32,287.53,262.11,280.41,252.43,279.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,271.82c-7.31,1.54-16.19,14.53-16.19,14.53s-3.46-6.61-2.78-8.05c2.78-5.78,9.25-10.45,11.79-11.15,1.16-.31,9.16,1.11,13.44,5.2A14.45,14.45,0,0,0,253.05,271.82Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,271.82c-7.31,1.54-16.19,14.53-16.19,14.53s-3.46-6.61-2.78-8.05c2.78-5.78,9.25-10.45,11.79-11.15,1.16-.31,9.16,1.11,13.44,5.2A14.45,14.45,0,0,0,253.05,271.82Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7,277.1c2.73-2.35,7.24-8.11,7.73-12.11s11-2.89,14.07-.78,2.69,8.48-1,12.89a9.76,9.76,0,0,0-7.92-3.79C252,273.2,244.7,277.1,244.7,277.1Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7,277.1c2.73-2.35,7.24-8.11,7.73-12.11s11-2.89,14.07-.78,2.69,8.48-1,12.89a9.76,9.76,0,0,0-7.92-3.79C252,273.2,244.7,277.1,244.7,277.1Z",
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.64,316.24a.71.71,0,0,0,.79.75l8.05-.62a1,1,0,0,0,.85-.88l.56-16a.81.81,0,0,0-.8-.86l-8,.63a1,1,0,0,0-.84,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.09,300l-.58,16.18c0,.46.24.75.69.71l6.83-.53c.46,0,1.27-.35,1.29-.81l.57-16.23c0-.46-.79-.76-1.25-.72l-6.82.53A.82.82,0,0,0,272.09,300Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,344.38c-2.33,4-6.47,9.24-11.83,9.24-8.54,0-33.8-21.74-21.31-30.87,5.51-4,14.58,5,17.68,7.51s12.8-6.67,12.8-6.67l.11,15.43A35.2,35.2,0,0,1,265.68,344.38Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,328.41l3.06-7.13s1-9.58,1.48-10.61,8.27-.64,9.11-.7.69,9.49-.13,10.49-4,1.82-4,1.82l-3.9,10.21Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,316.93c5.66-2.28,15.56,15.32,20.27,16.11s12.85-7.85,13.15-8.56,6,2.52,6.5,4-6.44,11.93-12,15.29-23.69-2.65-28-8.48C225.1,327.66,223.56,319.82,230.72,316.93Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,316.93c5.66-2.28,15.56,15.32,20.27,16.11s12.85-7.85,13.15-8.56,6,2.52,6.5,4-6.44,11.93-12,15.29-23.69-2.65-28-8.48C225.1,327.66,223.56,319.82,230.72,316.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUser);
export default __webpack_public_path__ + "static/media/mobileUser.04f17e5495eff84ff4cae8a5f3812cfc.svg";
export { ForwardRef as ReactComponent };